import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { images } from '../../../Profile/imagelinks';
import StickyButton from './StickyButton';
import ExitTimer from '../../ExitTimer';
const StickySection = ({activeChildProduct,activeChildButton, activeCard , dummyNumber ,razorpayHandler , setDowngradeModal, setIsCheckModal , proData, maxData , countDownDate, setIsDiscount,cardDatas,defaultSticky,setDefaultSticky}) => {
  const discountData = useSelector((store) => store?.userDiscount);

  const user_role = useSelector((store) => store?.userSubscription?.user_role);
  const isEligible = useSelector(
    (store) => store?.userSubscription?.isEligibleForLearntubeMax
  );
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768 ? true : false);


  const [randomImages , setRandomImages] = useState([])

  useEffect(()=>{
    const newArray = images?.sort((a,b)=> 0.5 - Math.random());
    setRandomImages(newArray.slice(0,5));




  },[])

console.log('maxData' , maxData);
useEffect(()=>{
  
  if (user_role === 7) {
    console.log('setting');
    let isTrailChild = maxData?.plan_button_states?.[2];
    setDefaultSticky((prev) => ({
      ...prev,
      first: isTrailChild?.state_buttons?.[0],
      second: {},
    }));
  } else if (maxData?.is_active_plan) {
    console.log('setting');
    let isActiveChild = maxData?.plan_button_states?.[3];
    setDefaultSticky((prev) => ({
      ...prev,
      first: isActiveChild?.state_buttons?.[0],
      second: {},
    }));
  } else if (isEligible) {
    console.log('setting');
    let isEligible = maxData?.plan_button_states?.[1];

    setDefaultSticky((prev) => ({
      ...prev,
      first: isEligible?.state_buttons?.[0],
      second: isEligible?.state_buttons?.[1],
    }));
  } else {
    console.log('setting');
    let defaultChild = maxData?.plan_button_states?.[0];

    setDefaultSticky((prev) => ({
      ...prev,
      first: defaultChild?.state_buttons?.[0],
      second: {},
    }));
  }
},[maxData])

  
 
  console.log('sticky' , activeCard?.plan_color_primary);

  return (
    <div className={`z-10 ${isDesktop ? `fixed top-0 justify-between items-center py-2` : 'sticky bottom-0 pb-8 pt-2 bg-white justify-between'} flex w-full  items-end  px-2 `}
    style={{
      background:
        isDesktop && `linear-gradient(418deg, ${activeCard?.plan_name === 'Downgrade' ? cardDatas?.[0]?.plan_color_primary: activeCard?.plan_color_primary} 16.15%, ${activeCard?.plan_name === 'Downgrade' ? cardDatas?.[0]?.plan_color_secondary : activeCard?.plan_color_secondary} 86.12%)`,
    }}>
      {
        isDesktop && <div className=' flex flex-row justify-center items-center text-xl text-white font-medium whitespace-nowrap w-2/5'>
          <div>Be The Winner! Upgrade to</div><img src={activeCard?.plan_name === 'Downgrade' ? cardDatas?.[0]?.plan_image : activeCard?.plan_image} width={20} height={20}
           className='ml-2 mr-2' alt="plan image"></img><div>{activeCard?.plan_name === 'Downgrade' ? 'LearnTube Pro' : activeCard?.plan_name}</div>
        </div>
      }
      <div className='w-full md:w-3/5 flex flex-row justify-end items-center'>
      {
        discountData ?  
        <div className='self-start mr-8'>
          <ExitTimer
          countDownDate={countDownDate}
          setIsDiscount={setIsDiscount}
          isSticky={true}
          />
        </div>
       : 
        <div className={`flex flex-col font-medium text-xs justify-center  md:mt-1 items-center ${isDesktop ? 'w-2/5' : 'w-1/2'}`}>
            <div className="flex">{randomImages?.map((e)=> <img src={e} className="w-8 h-8 md:w-7 md:h-7 rounded-full ring ring-white -ml-1"  alt="user images" width={window.innerWidth > 758 ? '28px': '32px'}
                                height={window.innerWidth > 758 ? '28px': '32px'}></img>)}</div>
            <div className='mt-1 md:mt-2 md:text-white'>{Math.min(dummyNumber,200)} Upgrades Today</div>
        </div>
      }
      <div className={`flex flex-col ${isDesktop? 'w-1/5' : 'w-1/2'} justify-center  items-center mr-8`}><StickyButton activeChildProduct={activeChildProduct} activeChildButton={activeChildButton} activeCard={activeCard} razorpayHandler={razorpayHandler} setDowngradeModal={setDowngradeModal} setIsCheckModal={setIsCheckModal} proData={proData} maxData={maxData} defaultSticky={defaultSticky} setDefaultSticky={setDefaultSticky} />
          </div>
          </div>
    </div>
      
  )
}

export default StickySection
